import axios, { AxiosError } from "axios";

export const extractAxiosErrorMessage = (
  error: any,
  defaultMessage = "An error occurred"
): string => {
  if (!axios.isAxiosError(error)) {
    return error instanceof Error ? error.message : defaultMessage;
  }

  if (axios.isCancel(error)) {
    return "Request was cancelled";
  }

  error = error as AxiosError;

  if (error.response?.data?.message) {
    return error.response.data.message;
  }

  if (error.response?.statusText) {
    return error.response.statusText;
  }

  if (error.request) {
    return "No response from server. Please check your connection.";
  }

  return error.message || defaultMessage;
};
